import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { faAdd, faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tab from '../../../../component/Tabs/Tab';
import ButtonOptionGroup from '../../component/ButtonOptions/ButtonOption';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';

const Purchases = () => {
  const navigate = useNavigate();
  const [keys, setKeys] = useState([]);
  const [columns, setColumns] = useState([]);

  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [amount, setAmount] = useState([]);
  const [data, setData] = useState([]);
  const [isNextPage, setIsNextPage] = useState(true);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [filterDate, setFilterDate] = useState("");
  const [filterKeyword, setFilterKeyword] = useState("");

  const [activeType, setActiveType] = useState("invoice");
  const tabHeader = [
    {
      "key": "invoice",
      "label": "Faktur",
    },
    {
      "key": "delivery",
      "label": "Pengiriman"
    },
    {
      "key": "order",
      "label": "Pemesanan"
    },
    {
      "key": "quote",
      "label": "Penawaran"
    }
  ];

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_PURCHASES = "api/erpppsu/purchases";
  const PATH_AMOUNT = "api/erpppsu/purchases/amount";

  // Fetch data from the API
  const fetchData = async (URL, config) => {
    try {
      const response = await axios.get(URL, config);
      return response.data; // Return only the data from the response
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_PURCHASES}?type=${activeType}`, {
      params: {
        offset: pageIndex,
        limit: pageSize
      }
    }).then((data) => {
      setData(data.data);
      setTotalRows(data.total);
    });

    fetchData(`${BASE_URL}${PATH_AMOUNT}`).then((data) => {
      setAmount(data);
    });
  }, [activeType]);

  useEffect(() => {
    setKeys(data.length > 0 ? Object.keys(data[0]) : []);
  }, [data]);

  useEffect(() => {
    setColumns(keys.map(key => ({
      Header: key.charAt(0).toUpperCase() + key.slice(1),
      accessor: key
    })));
  }, [keys]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (filterDate || filterKeyword) {
        fetchData(`${BASE_URL}${PATH_PURCHASES}/find`, {
          params: {
            type: activeType,
            date: filterDate,
            keyword: filterKeyword,
          }
        }).then((data) => {
          setData(data.data);
          setTotalRows(data.total);
        });
      }
    }, 500);

    return () => clearTimeout(handler);

  }, [filterDate, filterKeyword]);

  const handleTabClick = (tab) => {
    setActiveType(tab);
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  const options = [
    { value: 'invoice', label: 'Faktur Pembelian' },
    { value: 'order', label: 'Pemesanan Pembelian' },
    { value: 'quote', label: 'Penawaran Pembelian' }
  ];

  const handleDetail = (rowData) => {
    navigate(`/activity-erpppsu/purchases/detail/${rowData.id.value}`);
  };

  const actions = [{
    child: <button className='text-white text-xs rounded focus:ring bg-blue-500 hover:bg-blue-700 p-2 mx-1'>
      <FontAwesomeIcon icon={faInfo} color="white" />nfo
    </button>,
    callback: (rowData) => handleDetail(rowData)
  }];

  return (
    <div>
      <div className='flex items-center justify-between px-5'>
        <h1>Pembelian</h1>

        <div className='flex items-center'>
          <ButtonOptionGroup
            label={"Buat Pembelian Baru"}
            options={options}
            onChange={(value) => {
              navigate(`/activity-erpppsu/purchases/new/${value}`);
            }}
          />
        </div>
      </div>

      <div className="flex flex-wrap gap-4">
        {amount?.map((card, index) => (
          <div
            key={index}
            className={`w-96 p-4 rounded-lg shadow-md ${card.bgColor}`}
          >
            <div className="flex justify-between items-center">
              <h3 className="text-sm font-medium text-gray-800">{card.title}</h3>
              <span
                className={`text-xs font-bold px-2 py-1 rounded-full ${card.textColor} bg-white`}
              >
                {card.badge}
              </span>
            </div>
            <p className="text-lg font-semibold text-gray-900 mt-4">
              Total
            </p>
            <p className="text-2xl font-bold mt-2">Rp{card.total.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
          </div>
        ))}
      </div>

      <div className="tabs">
        {tabHeader.map((tab) => (
          <Tab name={tab.key} label={tab.label} activeTab={activeType} onClick={() => {
            handleTabClick(tab.key)
          }} />
        ))}
      </div>

      <div className="container m-auto grid grid-cols-4 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 my-3 gap-4">
        <div className="">
          <label htmlFor="date" className="block mb-1 text-sm font-semibold">Tanggal</label>
          <input
            id="date"
            name="date"
            type="date"
            className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            defaultValue={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
          />
        </div>
        <div className="">
          <label htmlFor="keyword" className="block mb-1 text-sm font-semibold">No. Transaksi / Pelanggan / Tags</label>
          <input
            id="keyword"
            name="keyword"
            type="text"
            autoComplete='off'
            className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            placeholder='Ketik disini'
            defaultValue={filterKeyword}
            onChange={(e) => setFilterKeyword(e.target.value)}
          />
        </div>
      </div>

      {loading ? (
        <center><h1>Loading...</h1></center>
      ) : (
        <DataTablePageDynamic
          data={data}
          nextPage={isNextPage}
          columns={columns}
          elementClass="p-1"
          actions={actions}
          onDataChange={(pageIndex, pageSize, sortBy) => {
            setPageIndex(pageIndex);
            fetchData(`${BASE_URL}${PATH_PURCHASES}?type=${activeType}`, {
              params: {
                offset: pageIndex,
                limit: pageSize
              }
            }).then((data) => {
              setIsNextPage(data.more > 0);
              setData(data.data);
              setTotalRows(data.total);
            });
          }} />
      )}

      <p>
        Menampilkan {Math.min(pageSize + pageIndex, totalRows)} dari {totalRows} Baris
      </p>
    </div>
  )
}

export default Purchases;
